import ReactDOM from "react-dom";
import { useRef } from "react";
import { C } from "./theme";
import { useModalFocus } from "./useModalFocus";
import { PAGE_WIDTH } from "./layout";

// A sheet from the bottom of the screen over a dimmed page: help, and questions asked before something happens.
// It owns the frame and focus (see useModalFocus); `startRef` is where focus starts. A tap outside or Escape
// calls onClose. Long content scrolls inside the sheet, so its buttons are never pushed off a short screen.
export function BottomSheet({ role = "dialog", labelledBy, describedBy, startRef, onClose, children }) {
  const sheetRef = useRef(null);
  useModalFocus({ containerRef: sheetRef, startRef, onClose });
  return ReactDOM.createPortal(
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 900, background: C.scrim }} />
      <div ref={sheetRef} role={role} aria-modal="true" aria-labelledby={labelledBy} aria-describedby={describedBy} onClick={e => e.stopPropagation()}
        style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 901, maxWidth: PAGE_WIDTH, margin: "0 auto", background: C.surface, color: C.text, borderRadius: "20px 20px 0 0", padding: "20px 20px 36px", boxShadow: C.sheetShadow, maxHeight: "80vh", overflowY: "auto" }}>
        <div aria-hidden="true" style={{ width: 36, height: 4, borderRadius: 2, background: C.border, margin: "0 auto 18px" }} />
        {children}
      </div>
    </>,
    document.body
  );
}
